import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
// Begning Confirmation
import { ConfirmationService } from '@jaspero/ng2-confirmations';
import { ResolveEmit } from '../../../app/resolve-emit';
import { ConfirmSettings } from '../../../app/confirm-settings';
// end of Confirmation
import { Menu } from '../../shared/menu.model';
import { EmployeePortalService }  from '../../shared/HR_ADMIN/EmployeePortal/EmployeePortalService.service';
import { DirectDuty }  from '../../shared/HR_ADMIN/EmployeePortal/DirectDuty.Model';
import { ModalOptions,BsModalRef, BsModalService  } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-direct-duty-approval',
  templateUrl: './direct-duty-approval.component.html',
  styleUrls: ['./direct-duty-approval.component.css']
})

export class DirectDutyApprovalComponent implements OnInit 
{
  DirectDutyApplication: DirectDuty[]=[];
  directduty: any;
  ModelListApplication: DirectDuty;
  userClaims: any;
  SubMenues : Menu[]=[];
  Mod : any;
  Approver: any;
  Result : string;
  SuccessStatus:boolean=false;
  SuccessMessage: string ="";
  public tableWidget: any;
  RefId : any;
  // Begning Permission Portion    
  SelectedMenu:Menu;
  IsDataIsInViewState : boolean=false;
  CanViewState : boolean=false;  
  CanApproveState : boolean=false; 
  GridShow : boolean=false; 
  DisableSave : boolean=false;
  // End of the permission portion
  // begin for Validation
  validdate : boolean= false;
  // end of validation
  //For Pop up
  TempDirectDuty : DirectDuty;
  ApprovedMsg : boolean= false;
  RejectedMsg : boolean= false;
  ShowPopup : boolean= false;
  public modalRef: BsModalRef;
  public modelopt:ModalOptions;
  NoRecordMsg :boolean;

  constructor(private EmployeePortalService:EmployeePortalService, private rout: Router, private _confirmation: ConfirmationService,  private userService: UserService,private modalService: BsModalService)
  { 
    this.ModelListApplication = new DirectDuty();
    this.ModelListApplication.IsFullDayDirectDuty=false;
    this.ModelListApplication.IsMorningDirectduty=false;
    this.ModelListApplication.IsSecondHalfDirectDuty=false;
    this.modelopt=new ModalOptions();
    this.modelopt.class='heavy_modal';
    this.modalService.config= this.modelopt;
    this.modelopt.ignoreBackdropClick=true;
  }

  ngOnInit() 
  {
    //Begin Permission Portion
    this.SelectedMenu=this.userService.SelectedMenu;
    if(this.SelectedMenu !=undefined)
    {
      localStorage.setItem('selectedmenu',JSON.stringify(this.SelectedMenu));
      this.rout.navigate([this.SelectedMenu.RouteName]);
    }
    else
    {
      if(JSON.parse(localStorage.getItem('selectedmenu'))!=undefined)
      {
        this.SelectedMenu = JSON.parse(localStorage.getItem('selectedmenu'));
        this.rout.navigate([this.SelectedMenu.RouteName]);
      }
    }
    if(this.SelectedMenu.CanAdd)
    {
      this.IsDataIsInViewState=false;
    }
    else
    {
      this.IsDataIsInViewState=true;
    }
    if(this.SelectedMenu.CanView)
    {
      this.CanViewState=false;
    }
    else
    {
      this.CanViewState=true;
    }
    if(this.SelectedMenu.CanApprove)
    {
      this.CanApproveState=false;
    }
    else
    {
      this.CanApproveState=true;
    }
    //End of the peremission portion
    this.DisableSave=true;
    this.GetAllApplication();
    this.ApprovedMsg=false;
    this.RejectedMsg=false;
    this.ShowPopup=false;
    this.NoRecordMsg= false;
  }

  settings: ConfirmSettings | any = 
  {
    overlay: true,
    overlayClickToClose: true,
    showCloseButton: true,
    confirmText: 'Yes',
    declineText: 'No'
  };

  GetAllApplication()
  {
    this.DirectDutyApplication=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeePortalService.GetEmployeeDirectDutyForApproval( t).then(x => 
    {
      this.Approver = x;
      Object.keys(this.Approver).forEach( key => 
      {
        this.NoRecordMsg= false;
        this.Approver[key];
        let ApproveLeave = new DirectDuty();
        ApproveLeave = this.Approver[key];
        this.DirectDutyApplication.push(ApproveLeave);
      });
      if(this.DirectDutyApplication.length==0)
      {
        this.NoRecordMsg= true;
      }
    });
  }

  viewAppliedDirectDuty(id,template) 
  {
    this.ModelListApplication.Remarks="";
    this.GridShow=true;
    // Begning of the permission portion
    this.IsDataIsInViewState=false;
    // End of the permision portion
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeePortalService.GetEmployeeDirectDutyForApprovalById( t,id).then(x => 
    {
      if(this.ShowPopup==true)
      {
        this.modalRef.hide();
      }
      this.modalRef = this.modalService.show(template,this.modelopt);
      this.ShowPopup = true;
      this.ApprovedMsg = false;
      this.RejectedMsg = false;
      this.Approver = x;
      Object.keys(this.Approver).forEach( key => 
      {
        // tslint:disable-next-line:no-unused-expression
        this.Approver[key];
        let Approvetemp = new DirectDuty();
        Approvetemp = this.Approver[key];
        this.ModelListApplication.DirectId=Approvetemp.DirectId;
        this.ModelListApplication.EmpId=Approvetemp.EmpId;
        this.ModelListApplication.EmployeeCode=Approvetemp.EmployeeCode;
        this.ModelListApplication.EmployeeName=Approvetemp.EmployeeName; 
        this.ModelListApplication.EmployeeEmailId=Approvetemp.EmployeeEmailId; 
        this.ModelListApplication.RHCode=Approvetemp.RHCode;
        this.ModelListApplication.RHName=Approvetemp.RHName; 
        this.ModelListApplication.RHEmailId=Approvetemp.RHEmailId; 
        this.ModelListApplication.DateOfDirectDuty=Approvetemp.DateOfDirectDuty; 
        this.ModelListApplication.IsFullDayDirectDuty=Approvetemp.IsFullDayDirectDuty;
        if(Approvetemp.IsFullDayDirectDuty==true)
        {
          this.ModelListApplication.Fullday="Fullday";
          this.ModelListApplication.FirstHalf="";
          this.ModelListApplication.SecondHalf="";
        }
        this.ModelListApplication.IsMorningDirectduty=Approvetemp.IsMorningDirectduty;
        if(Approvetemp.IsMorningDirectduty==true)
        {
          this.ModelListApplication.FirstHalf="FirstHalf";
          this.ModelListApplication.Fullday="";
          this.ModelListApplication.SecondHalf="";
        }
        this.ModelListApplication.IsSecondHalfDirectDuty=Approvetemp.IsSecondHalfDirectDuty;
        if(Approvetemp.IsSecondHalfDirectDuty==true)
        {
          this.ModelListApplication.SecondHalf="SecondHalf";
          this.ModelListApplication.Fullday="";
          this.ModelListApplication.FirstHalf="";
        }
        this.ModelListApplication.Place=Approvetemp.Place; 
        this.ModelListApplication.Reason=Approvetemp.Reason; 
        this.ModelListApplication.CompanyId=Approvetemp.CompanyId;
        this.ModelListApplication.SentMailid=Approvetemp.SentMailid;
        this.ModelListApplication.SentMailPassword=Approvetemp.SentMailPassword;
        this.ModelListApplication.HRISURL=Approvetemp.HRISURL;
      });
      // End for check company code duplication
    });
  }
  
  DirectDutyApproved(template) :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    if(this.ModelListApplication.DirectId > 0)
    {
      this.ModelListApplication.IsApproved=true;
      this.ModelListApplication.IsRejected=false;
      this.EmployeePortalService.UpdateEmployeeDirectDuty(t ,this.ModelListApplication).subscribe(res=>
      {
        this.RefId=res;
        this.ModelListApplication.DirectId=0;  
        if(this.RefId>0)
        {
          this.ModelListApplication.Remarks="";
          this.ModelListApplication.RemarksAll="";
          this.modalRef.hide();
          this.ApprovedMsg=true;
          this.RejectedMsg=false;
          this.ShowPopup=false;
          this.modalRef = this.modalService.show(template);
          this.DirectDutyApplication=[];
          this.GetAllApplication();
          this.DisableSave=true;
        }
      });                  
    }
  }

  DirectDutyRejected(template) :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    if(this.ModelListApplication.DirectId > 0)
    {
      this.ModelListApplication.IsApproved=false;
      this.ModelListApplication.IsRejected=true;
      this.EmployeePortalService.UpdateEmployeeDirectDuty(t ,this.ModelListApplication).subscribe(res=>
      {
        this.RefId=res;
        this.ModelListApplication.DirectId=0;  
        if(this.RefId>0)
        {
          this.ModelListApplication.Remarks="";
          this.ModelListApplication.RemarksAll="";
          this.modalRef.hide();
          this.ApprovedMsg=false;
          this.RejectedMsg=true;
          this.ShowPopup=false;
          this.modalRef = this.modalService.show(template);
          this.DirectDutyApplication=[];
          this.GetAllApplication();
          this.DisableSave=true;
        }
      });                  
    }
  }

  RefreshPage()
  {
    this.rout.navigateByUrl('/AdminApproveOrReject/Leave', {skipLocationChange: true}).then(()=>this.rout.navigate(["/AdminApproveOrReject/DirectDuty"]));
  }

  SelectedChange(rowid,ev)
  {
    this.TempDirectDuty =this.DirectDutyApplication[rowid];
    if(ev.target.checked==true)
    {
      this.TempDirectDuty.Selected=true;
    }
    else
    {
      this.TempDirectDuty.Selected=false;
    }
  }

  checkAll(ev) 
  {
    if(ev.target.checked == true)
    {
      var J=this.DirectDutyApplication.length;
      for(var i=0;i<J;i++) 
      {
        this.DirectDutyApplication[i].Selected=true;
      }
    }
    else
    {
      var J=this.DirectDutyApplication.length;
      for(var i=0; i<J; i++)
      {
        this.DirectDutyApplication[i].Selected=false;
      }
    }
  }

  DirectDutyApprovedAll(template) :void
  {
    if(this.DirectDutyApplication.length > 0)
    {
      this._confirmation.create('Confirm to Approve', 'Press Yes to Approve', this.settings)
      .subscribe((ans: ResolveEmit) => 
      {
        if (ans.resolved == true) 
        {
          this.DisableSave=false;
          let t =  localStorage.getItem('userToken');
          t = 'Bearer' + t;
          var j=0;
          var l=this.DirectDutyApplication.length;
          this.DirectDutyApplication.forEach(item => 
          {
            j=j+1;
            if(item.DirectId > 0 && item.Selected == true)
            {
              item.Remarks=this.ModelListApplication.RemarksAll;
              item.IsApproved=true;
              item.IsRejected=false;
              this.EmployeePortalService.UpdateEmployeeDirectDuty(t ,item).subscribe(res=>
              {
                this.RefId=res;
                item.DirectId=0;  
                if(j == this.DirectDutyApplication.length)
                {
                  if(this.ShowPopup==true)
                  {
                    this.modalRef.hide();
                  }
                  this.ModelListApplication.Remarks="";
                  this.ModelListApplication.RemarksAll="";
                  this.ApprovedMsg=true;
                  this.RejectedMsg=false;
                  this.ShowPopup=false;
                  this.modalRef = this.modalService.show(template);
                  this.DirectDutyApplication=[];
                  this.GetAllApplication();
                  this.DisableSave=true;
                }
              });                  
            }
          })
        }
      })
    }
  }

  DirectDutyRejectedAll(template) :void
  {
    if(this.DirectDutyApplication.length > 0)
    {
      this._confirmation.create('Confirm to Reject', 'Press Yes to Reject', this.settings)
      .subscribe((ans: ResolveEmit) => 
      {
        if (ans.resolved == true) 
        {
          this.DisableSave=false;
          let t =  localStorage.getItem('userToken');
          t = 'Bearer' + t;
          var j=0;
          var l=this.DirectDutyApplication.length;
          this.DirectDutyApplication.forEach(item => 
          {
            j=j+1;
            if(item.DirectId > 0 && item.Selected == true)
            {
              item.Remarks=this.ModelListApplication.RemarksAll;
              item.IsApproved=false;
              item.IsRejected=true;
              this.EmployeePortalService.UpdateEmployeeDirectDuty(t ,item).subscribe(res=>
              {
                this.RefId=res;
                item.DirectId=0;  
                if(j == this.DirectDutyApplication.length)
                {
                  if(this.ShowPopup==true)
                  {
                    this.modalRef.hide();
                  }
                  this.ModelListApplication.Remarks="";
                  this.ModelListApplication.RemarksAll="";
                  this.ApprovedMsg=false;
                  this.RejectedMsg=true;
                  this.ShowPopup=false;
                  this.modalRef = this.modalService.show(template);
                  this.DirectDutyApplication=[];
                  this.GetAllApplication();
                  this.DisableSave=true;
                }
              });                  
            }
          })
        }
      })
    }
  }
}